export const contactsData = {
  email: "Sangam.choudhary7@gmail.com",
  phone: "+91 7531867962",
  address: "Delhi",

  sheetAPI: "",
};
